const IS_MAP_SYMBOL = '@@__IMMUTABLE_MAP__@@'
const ITERATOR_SYMBOL_REAL = typeof Symbol === 'function' && Symbol.iterator
const ITERATOR_SYMBOL_FAUX = '@@iterator'
const ITERATOR_SYMBOL = ITERATOR_SYMBOL_REAL || ITERATOR_SYMBOL_FAUX

// Used for setting reserved keyword `delete` as named-property.
const DELETE = 'delete'

// A consistent shared value representing "not set" which equals nothing other
// than itself, and nothing that could be provided externally.
const NOT_SET = {}
const DONE = {}

// TODO consider removing these
const SHAPE_MAP = 'map'
const SHAPE_NODELIST = 'nodeList'
const SHAPE_NODEVALUE = 'nodeValue'
const SHAPE_NODEARRAYMAP = 'nodeArrayMap'
const SHAPE_NODEHASHARRAYMAP = 'nodeHashArrayMap'
const SHAPE_NODEHASHCOLLISION = 'nodeHashCollision'
const SHAPE_NODEBITMAPINDEXED = 'nodeBitmapIndexed'

const ITERATE_TYPE_KEYS = 0
const ITERATE_TYPE_VALUES = 1
const ITERATE_TYPE_ENTRIES = 2

export {
  ITERATE_TYPE_KEYS,
  ITERATE_TYPE_KEYS as ITERATE_KEYS,
  ITERATE_TYPE_VALUES,
  ITERATE_TYPE_VALUES as ITERATE_VALUES,
  ITERATE_TYPE_ENTRIES,
  ITERATE_TYPE_ENTRIES as ITERATE_ENTRIES,
  IS_MAP_SYMBOL,
  ITERATOR_SYMBOL_REAL,
  ITERATOR_SYMBOL_FAUX,
  ITERATOR_SYMBOL,
  DELETE,
  NOT_SET,
  DONE,
  SHAPE_MAP,
  SHAPE_NODELIST,
  SHAPE_NODEVALUE,
  SHAPE_NODEARRAYMAP,
  SHAPE_NODEHASHARRAYMAP,
  SHAPE_NODEHASHCOLLISION,
  SHAPE_NODEBITMAPINDEXED
}
